import React, { useEffect, useState } from 'react';

import CodeEditorExpandable from '../CodeEditorExpandable';
import { CodeEditorSize } from '../CodeEditorExpandable/types';
import { MONACO_FULL_EDITOR_OPTIONS, MONACO_LITE_EDITOR_OPTIONS } from '../CodeEditorExpandable/const';
import JsonEditor from '../JsonEditor';
import { getDefaultIfUndefined } from '../../../utils/typeUtil';
import { CodeEditorStatus } from '../CodeEditor/types';
import { DEFAULT_EDITOR_STATUS } from '../CodeEditor/const';

import { DEFAULT_EDITOR_SIZE } from './const';

export interface IJsonEditorExpandableProps {
  className?: string;
  value?: string;
  size?: CodeEditorSize;
  status?: CodeEditorStatus;
  readOnly?: boolean;
  expanded?: boolean;
  toolbar?: boolean;
  codeFolder?: string;
  schema?: { [key: string]: unknown } | null;
  onChange?: (value?: string) => void;
  onValidate?: (errors: string[], status: CodeEditorStatus, value?: string) => void;
  onExpand?: () => void;
  onCollapse?: () => void;
}

const JsonEditorExpandable: React.FC<IJsonEditorExpandableProps> = ({
  className,
  value,
  size = DEFAULT_EDITOR_SIZE,
  status = DEFAULT_EDITOR_STATUS,
  readOnly,
  expanded,
  toolbar = true,
  codeFolder,
  schema,
  onChange,
  onValidate,
  onExpand,
  onCollapse,
}) => {
  size = getDefaultIfUndefined(size, DEFAULT_EDITOR_SIZE);

  const [isFullscreen, setIsFullscreen] = useState(expanded || false);

  const onExpandedPropChange = () => {
    expanded !== undefined && setIsFullscreen(expanded);
  };

  useEffect(onExpandedPropChange, [expanded]);

  const onFullscreenToggle = (value: boolean) => {
    setIsFullscreen(value);
    value && onExpand?.();
    !value && onCollapse?.();
  };

  return (
    <CodeEditorExpandable
      className={className}
      isFullscreen={isFullscreen}
      readOnly={readOnly}
      size={size}
      status={status}
      toolbar={toolbar}
      onFullscreenToggle={onFullscreenToggle}
    >
      <JsonEditor
        codeFolder={codeFolder}
        isFullscreen={isFullscreen}
        options={isFullscreen ? MONACO_FULL_EDITOR_OPTIONS : MONACO_LITE_EDITOR_OPTIONS}
        readOnly={readOnly}
        schema={schema}
        value={value || ''}
        onChange={onChange}
        onValidate={onValidate}
      />
    </CodeEditorExpandable>
  );
};

export default JsonEditorExpandable;
